import process from "process";

const development: boolean = process.env.NODE_ENV === 'development';

export function isDev(): boolean
{
    return development;
}